
import * as React from 'react';

export const ResponsiveImage = ({ className, basePath, fileName, extension, alt }) => (
  <picture className={className}>
    <source media='(max-width: 576px)' srcSet={`/static${basePath}/${fileName}.${extension}`} />
    <img src={`/static${basePath}/${fileName}@2x.${extension}`} alt={alt} />
  </picture>
);
